export function percentFormat(percent: number, fractionDigits = 2): string {
  if (isNaN(percent)) return '';
  return `${(percent * 100).toFixed(fractionDigits)}%`;
}
